import { debounce } from 'lodash';
import { Controller } from 'stimulus';
import Swiper, {EffectFade, Pagination} from 'swiper';

Swiper.use([EffectFade, Pagination]);

export default class extends Controller {
  static targets = ['slider', 'pagination'];

  connect() {
    this.initSwiper();
    this.handleResize = debounce(this.onResize.bind(this), 200);
    window.addEventListener('resize', this.handleResize);
  }

  disconnect() {
    window.removeEventListener('resize', this.handleResize);
    if (this._initTimer) {
      clearTimeout(this._initTimer);
      this._initTimer = null;
    }
    this.destroySwiper();
  }

  initSwiper() {
    this._initTimer = setTimeout(() => {
      if (window.innerWidth < 768 && !this.swiper) {
        this.swiper = new Swiper(this.sliderTarget, {
          slidesPerView: 1,
          centeredSlides: true,
          speed: 800,
          effect: 'fade',
          autoHeight: true,
          fadeEffect: {
            crossFade: true,
          },
          pagination: {
            el: this.paginationTarget,
            clickable: true,
          },
          on: {
            init: function(swiper) {
              setTimeout(() => {
                swiper.updateAutoHeight();
              }, 100);
            }
          }
        });
      }
      this._initTimer = null;
    }, 0);
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  onResize() {
    if (window.innerWidth < 768) {
      if (!this.swiper) {
        this.initSwiper();
      }
    } else {
      this.destroySwiper();
    }
  }
}
